import { render, staticRenderFns } from "./addReasonModal.vue?vue&type=template&id=3c68f4cc&scoped=true"
import script from "./addReasonModal.vue?vue&type=script&lang=js"
export * from "./addReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68f4cc",
  null
  
)

export default component.exports